export const AUTHING_APP_ID = '6389cf494b2e2b25f818ab6d';
